export default "__VITE_ASSET__tAy0uKWS__"